<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <News
        :type="type"
        :id="id"
        :block="block"
        :status="status"
        :push="push"
        :pageType="pageType"
      ></News>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import News from "@/components/news";
export default {
  data() {
    return {
      navBlock: "新聞  /  新聞列表",
      navtitle: this.$route.query.pageType == "edit" ? "修改新聞" : "草稿箱",
      type: this.$route.query.pageType,
      id: this.$route.query.id,
      block: this.$route.query.type,
      status: this.$route.query.status,
      push: this.$route.query.push,
      pageType: this.$route.query.pageType,
    };
  },
  methods: {},
  components: {
    NavBar,
    News,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/news/news/editNews.vue